import {
  ENVIRONMENT,
  APP_NAME,
} from 'src/app/constants/configObjectProperties';
import { VERSION_PARAM } from 'src/app/constants/queryParams';
import { getConfig } from 'src/app/utils/config';
import { isServerRendering } from 'src/app/utils/environment';

const getStorageItemKey = (): string =>
  [
    `app:${getConfig(APP_NAME)}`,
    `env:${getConfig(ENVIRONMENT)}`,
    `param:${VERSION_PARAM}`,
  ].join('|');

export const getUivInStorage = (): string | null => {
  if (isServerRendering()) {
    return null;
  }
  return sessionStorage.getItem(getStorageItemKey());
};

export const setUivInStorage = (uiv?: string): void => {
  if (isServerRendering() || !uiv) {
    return;
  }
  sessionStorage.setItem(getStorageItemKey(), uiv);
};

export const removeUivInStorage = (): void => {
  if (isServerRendering()) {
    return;
  }
  sessionStorage.removeItem(getStorageItemKey());
};
